import apiConfig from '../api-config';
const api_base_url = apiConfig.api_base_url;
const api_key = apiConfig.api_key;

export const getFeed = async (userId) => {
  const token = sessionStorage.getItem('authToken');
  try {
    const response = await fetch(`${api_base_url}/api/${api_key}/get/${userId}/rss/news`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to get feed');
    }

    return response.json();
  } catch (error) {
    console.error('Error getting feed:', error);
    throw error;
  }
};
